export function normalizeSpreadsheetDecimal(value) {
  const text = String(value ?? '').replace(/\u00a0/g, ' ').trim();
  if (!text) return { valid: true, value: '' };

  const compact = text.replace(/\s+/g, '');
  if (!/^[+-]?(?:\d+(?:[.,]\d*)?|[.,]\d+)(?:[eE][+-]?\d+)?$/.test(compact)) {
    return { valid: false, value: text };
  }

  const normalized = compact.replace(',', '.');
  return Number.isFinite(Number(normalized))
    ? { valid: true, value: normalized }
    : { valid: false, value: text };
}

export function parseSpreadsheetGrid(text) {
  const rows = String(text ?? '').replace(/\r\n?/g, '\n').split('\n');
  while (rows.length > 1 && rows[rows.length - 1] === '') rows.pop();
  return rows.map((row) => row.split('\t'));
}

export function applySpreadsheetGrid(rows = [], fields = [], startRow = 0, startField = '', text = '') {
  const matrix = parseSpreadsheetGrid(text);
  const startColumn = fields.indexOf(startField);
  const nextRows = rows.map((row) => ({ ...row }));
  const assignments = [];
  const invalidCells = [];
  let truncated = 0;

  if (startColumn < 0 || startRow < 0 || startRow >= nextRows.length) {
    return { rows: nextRows, assignments, invalidCells, truncated: matrix.flat().length };
  }

  matrix.forEach((sourceRow, rowOffset) => {
    sourceRow.forEach((sourceValue, columnOffset) => {
      const rowIndex = startRow + rowOffset;
      const field = fields[startColumn + columnOffset];
      if (!nextRows[rowIndex] || !field) {
        truncated += 1;
        return;
      }
      const normalized = normalizeSpreadsheetDecimal(sourceValue);
      if (!normalized.valid) {
        invalidCells.push({ rowIndex, field, value: sourceValue });
        return;
      }
      nextRows[rowIndex][field] = normalized.value;
      assignments.push({ rowIndex, field, value: normalized.value });
    });
  });

  return { rows: nextRows, assignments, invalidCells, truncated };
}
